import { useState, useEffect } from 'react'

const DEMO_MODE_KEY = 'agenix_demo_mode'

export const useDemoMode = () => {
  const [isDemoMode, setIsDemoMode] = useState(() => {
    const stored = localStorage.getItem(DEMO_MODE_KEY)
    return stored === 'true'
  })

  useEffect(() => {
    localStorage.setItem(DEMO_MODE_KEY, isDemoMode.toString())
  }, [isDemoMode])

  const toggleDemoMode = () => {
    setIsDemoMode(prev => !prev)
  }

  return { isDemoMode, toggleDemoMode, setIsDemoMode }
}

export const getDemoMode = () => {
  const stored = localStorage.getItem(DEMO_MODE_KEY)
  return stored === 'true'
}


